import { Building2, Trees, Home } from 'lucide-react';

export const PropertyTypeIcon = ({ type = '', className }) => {
  const t = type.toLowerCase();
  if (t.includes('condo') || t.includes('apartment') || t.includes('co-op')) {
    return <Building2 className={className} />;
  }
  if (t.includes('land') || t.includes('lot')) {
    return <Trees className={className} />;
  }
  return <Home className={className} />;
};
